import stripNonNumbers from './stripNonNumbers';

export default function invalidPhone(phn) {
    if (!phn) return false;
    return stripNonNumbers(phn).length !== 10;
}
